import API_URL from "@/globals/api";
import axiosInstance from "./api";

// The billing portal moved to stripe.service.js (`openBillingPortal`). It used
// to live here as `createPortalSession(userId)`, which sent the user id in the
// query string and expected to consume a 303 to billing.stripe.com over XHR —
// the browser blocks that hop on CORS, so the call could never succeed.
class SubscriptionService {
  getSubscriptions() {
    return axiosInstance.get(`${API_URL}/subscriptions/subscriptions`);
  }
}

export default new SubscriptionService();
